import { format, formatISO } from 'date-fns'
import React, { useEffect } from 'react'
import DatePicker from 'react-datepicker'
import { useSearchParams } from 'react-router-dom'

import Calendar2Icon from '../assets/img/ico-calendar-2.svg?react'
import type { DateRangeQueryParams } from '../services/types'
import type { RevenueGraph } from '../types/executives'
import { getStartAndEndOfWeek } from '../utils/helpers'

import LineChart from './charts/LineChart'
interface IGraphParams {
    params: DateRangeQueryParams
    revenueGraph: RevenueGraph[]
}
const Graph = ({ params, revenueGraph }: IGraphParams) => {
    const [searchParams, setSearchParams] = useSearchParams()
    useEffect(() => {
        if (params.startDate && params.endDate) return
        const { startDate, endDate } = getStartAndEndOfWeek(new Date())
        setSearchParams((prev) => {
            prev.set('startDate', startDate)
            prev.set('endDate', endDate)
            return prev
        })
    }, [])
    return (
        <div className="col-12">
            <div className="card card-shadow card-chart h-full">
                <div className="card-header">
                    <div
                        className="flex items-center w-full"
                        style={{ maxWidth: '250px' }}
                    >
                        <DatePicker
                            wrapperClassName="w-full"
                            selectsRange={true}
                            startDate={
                                params.startDate === 'null' || !params.startDate
                                    ? undefined
                                    : new Date(params.startDate)
                            }
                            endDate={
                                params.endDate === 'null' || !params.endDate
                                    ? undefined
                                    : new Date(params.endDate)
                            }
                            className="calendar-title"
                            onChange={(date) => {
                                if (!date) return
                                setSearchParams((prev) => {
                                    prev.set(
                                        'startDate',
                                        date[0]
                                            ? formatISO(date[0])
                                            : String(date[0]),
                                    )
                                    prev.set(
                                        'endDate',
                                        date[1]
                                            ? formatISO(date[1])
                                            : String(date[1]),
                                    )
                                    return prev
                                })
                            }}
                            dateFormat={'MMM d, yyyy'}
                        />
                        <span className="ico absolute right-4">
                            <Calendar2Icon />
                        </span>
                    </div>
                    {/* <button className="btn">
                                    <span className="ico me-3">
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.1665 13.3334H10.8332V5.83335H13.3332L9.99984 1.66669L6.6665 5.83335H9.1665V13.3334Z"
                                                fill="#232ED1"
                                            ></path>
                                            <path
                                                d="M4.16667 18.3333H15.8333C16.7525 18.3333 17.5 17.5858 17.5 16.6667V9.16667C17.5 8.2475 16.7525 7.5 15.8333 7.5H12.5V9.16667H15.8333V16.6667H4.16667V9.16667H7.5V7.5H4.16667C3.2475 7.5 2.5 8.2475 2.5 9.16667V16.6667C2.5 17.5858 3.2475 18.3333 4.16667 18.3333Z"
                                                fill="#232ED1"
                                            ></path>
                                        </svg>
                                    </span>
                                    <span className="color-primary">
                                        Export
                                    </span>
                                </button> */}
                </div>
                <div className="card-body">
                    <div
                        className="canvas-wrapper flex-auto"
                        style={{ height: 215 }}
                    >
                        <LineChart
                            values={revenueGraph.map(
                                (item) => item.totalRevenue,
                            )}
                            labels={revenueGraph.map((item) =>
                                format(new Date(item.date), 'MMM dd'),
                            )}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Graph
